import type { HomePageLog } from '@/app/_shared/protobuf-log/clientlogs/home-common-txtpb';
import type { SubhomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import {
  FamilyHomePageLog,
  LeisureHomePageLog,
} from '@/app/_shared/protobuf-log/clientlogs/sub-home-leisure-common-txtpb';

import { EntertainmentHomePageLog } from '@/app/_shared/protobuf-log/clientlogs/sub-home-entertainment-common-txtpb';
import { TransportationHomePageLog } from '@/app/_shared/protobuf-log/clientlogs/sub-home-transportation-common-txtpb';

/**
 * ProtoBuf 로그 action 함수
 */

type ImpressionArg = Parameters<typeof HomePageLog.QuickCategoryBoardRowItem.impression>[0];
type ClickArg = Parameters<typeof HomePageLog.QuickCategoryBoardRowItem.click>[0];
interface LogAction {
  impression: (arg: ImpressionArg) => void;
  click: (arg: ClickArg) => void;
}

const sHomeLogHandler: Partial<Record<SubhomeLogPageNameValue, LogAction>> = {
  FamilyHome: FamilyHomePageLog.QuickCategoryBoardRowItem,
  LeisureHome: LeisureHomePageLog.QuickCategoryBoardRowItem,
  EntertainmentHome: EntertainmentHomePageLog.QuickCategoryBoardRowItem,
  TransportationHome: TransportationHomePageLog.QuickCategoryBoardRowItem,
};

/** protobuf 로그를 호출하는 함수
 * @param fn - protobuf 로그 메소드
 * @param logMeta - 로그 메타
 */
export const clientLogProtobuf =
  <T extends ImpressionArg | ClickArg>(fn: (arg: T) => void, logMeta?: T, target?: string): (() => void) =>
  () => {
    if (!logMeta) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(`protobuf-log not found\n${fn.toString()}`);
      }
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.log('protobuf-log', fn.name, logMeta);
    }

    // TODO : SubHome의 target 에 따라서 호출하는 함수를 변경해야함
    if (!!target && sHomeLogHandler[target as SubhomeLogPageNameValue]) {
      const handler = sHomeLogHandler[target as SubhomeLogPageNameValue];
      const method = fn.name as 'click' | 'impression';

      if (handler?.[method]) {
        handler[method](logMeta);
      }
    } else {
      fn(logMeta);
    }
  };
